import React from "react";
import { Dropdown } from "react-bootstrap";

const CheckboxItem = ({ id, isChecked, checkHandler, label, icon }) => {
  return (
    <Dropdown.Item href={`#/action-${id}`}>
      <input
        className="form-check-input"
        type="checkbox"
        value=""
        id={id}
        checked={isChecked}
        onChange={checkHandler}
      />
      <label htmlFor={id}>
        {isChecked ? (
          <span style={{ color: "black" }} className="p-1">
            {" "}
            <img src={icon} alt={`${label} icon`} width={20} height={20} />{" "}
            {label}
          </span>
        ) : (
          <span style={{ color: "#5F6368" }} className="p-1">
            {" "}
            <img
              src={icon}
              alt={`${label} light icon`}
              width={20}
              height={20}
            />{" "}
            {label}
          </span>
        )}
      </label>
    </Dropdown.Item>
  );
};

export default CheckboxItem;
